import { type IconButtonProps } from '@naf-simba/elements-buttons';

export type LegacyIconButtonVariant = 'primary' | 'secondary' | 'secondary-inverted' | 'outline' | 'neutral';

// IconButton's color only supports shaded colors (primary/secondary/critical), unlike the regular Button.
const variantsMap = new Map<LegacyIconButtonVariant, Pick<IconButtonProps, 'variant' | 'color' | 'shade'>>([
  ['primary', { color: 'primary', variant: 'contained' }],
  ['secondary', { color: 'secondary', variant: 'contained' }],
  ['secondary-inverted', { color: 'secondary', variant: 'contained', shade: 'light' }],
  ['outline', { color: 'primary', variant: 'outlined' }],
  ['neutral', { color: 'secondary', variant: 'outlined' }],
]);

export const mapSimbaIconButtonVariant = (
  variant: LegacyIconButtonVariant = 'outline',
): Pick<IconButtonProps, 'variant' | 'color' | 'shade'> => variantsMap.get(variant) ?? variantsMap.get('outline')!;
